module.exports = __webpack_public_path__ + "crown.7e0035c4.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/crown.svg
// module id = WteR
// module chunks = 0